import { GetDateTime } from '../../../../utils/Show';
import { TextCapitalize } from '../../../../utils/TextFormatter';
import cn from '../../../../utils/cn';

function Container({ children, cardTitle, className }) {
    return (
        <div
            className={cn(
                'relative max-h-[100px] w-full md:max-w-[320px] p-5 !pb-2.5 bg-[rgba(0,145,110,0.5)] rounded-10 border border-[rgba(255,255,255,0.5)]',
                className
            )}
        >
            {children}

            {cardTitle ? (
                <span className="flex items-center justify-center min-h-7 bg-white text-primary text-sm font-normal absolute -top-4 left-4 px-2.5 rounded-[7px] box-border">
                    {cardTitle}
                </span>
            ) : null}
        </div>
    );
}

function InfoRow({ title, value }) {
    return (
        <div className="flex gap-x-2 text-sm text-white">
            <div className="whitespace-nowrap">
                <span>{title}:</span>
            </div>
            <div className="whitespace-nowrap">
                <span>{value || '------'}</span>
            </div>
        </div>
    );
}

function UserInfo({ data }) {
    const { userInfo } = data;
    return (
        <Container cardTitle="User Info">
            <InfoRow title="Name" value={userInfo?.fullName} />
            <InfoRow title="Phone" value={userInfo?.phone} />
            <InfoRow title="Email" value={userInfo?.email} />
            <span className="bg-[#FFA016] text-sm text-white py-[3px] px-2.5 rounded-[4px] absolute -top-4 right-[6px]">
                {TextCapitalize(userInfo?.status) || '--'}
            </span>
        </Container>
    );
}

function AuthInfo({ data }) {
    const { authInfo } = data;
    return (
        <Container cardTitle="Auth Info">
            <InfoRow title="2FA Status" value={authInfo?.tfaStatus ? 'Yes' : 'No'} />
            <InfoRow title="Last Login" value={GetDateTime(authInfo?.timeLastLogin)} />
            <InfoRow title="IP Info" value={authInfo?.lastLoginIp} />
        </Container>
    );
}

function AdminInfoCard({ data }) {
    return (
        <div className="flex flex-wrap lg:flex-nowrap gap-y-6 gap-x-2.5 relative z-10">
            <UserInfo data={data} />
            <AuthInfo data={data} />
        </div>
    );
}

export default AdminInfoCard;
